import { Component, OnInit } from '@angular/core';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { Tbcobrador } from './shared/tbcobrador.model';

@Component({
  selector: 'app-cobrador',
  templateUrl: './cobrador.component.html',
  styleUrls: ['./cobrador.component.scss']
})
export class CobradorComponent implements OnInit {
  private client: GraphQLClient = null;
  cobradorList: Tbcobrador[];
  selectedCobrador: Tbcobrador;
  cobrador: Tbcobrador;

  constructor(client: GraphQLClient) { 
    this.client = client;
  }

  ngOnInit() {
    this.selectedCobrador = {
      cobid: null,
      cobcodigo: '', 
      cobnombre: '', 
      cobrut: '', 
      cobcargo: '',
      cobzona: '',
      cobseccion: '',
      cobcomision: null
    };
    this.obtenerDatosCobrador();
  }

  obtenerDatosCobrador() {
    //console.log("obtenerDatosnew")
    let self = this; // this is unused

    this.client.query({
      query: gql`
          query {
            tbCobrador{
              obtenerTodos {
                respuesta
                {
                  registros
                  {
                    cobid
                    cobcodigo
                    cobnombre
                    cobrut
                    cobcargo
                    cobzona
                    cobseccion
                    cobcomision
                  }
                }
              }
            }
          }
      `
    }, function (respuesta) {

      self.cobradorList = respuesta.data.tbCobrador.obtenerTodos.respuesta.registros;

    });
  }

  showForEdit(cob: Tbcobrador) {
    //console.log(vend);
    this.selectedCobrador = Object.assign({}, cob);
  }


  insertar(cobid: number, cobcodigo: string, cobnombre: string, cobrut: string, cobcargo: string, cobzona: string, cobseccion: string, cobcomision: any) {//, trID: number
    //console.log(cobcomision);
    this.cobrador = { cobid: 0, cobcodigo: cobcodigo, cobnombre: cobnombre, cobrut: cobrut, cobcargo: cobcargo, cobzona: cobzona, cobseccion: cobseccion, cobcomision: parseFloat(cobcomision) };
    //console.log(this.cobrador);
    this.postCobrador(this.cobrador);
    
    this.selectedCobrador = {
      cobid: null,
      cobcodigo: '', 
      cobnombre: '', 
      cobrut: '', 
      cobcargo: '',
      cobzona: '',
      cobseccion: '',
      cobcomision: null
    };
    // console.log(veFono2);
    //console.log('inserto');
  }

  postCobrador(cob: Tbcobrador) {
    let self = this;
    var bodyx = cob;
    //console.log(bodyx);
    //var self = this;
    this.client.mutate({
      mutation: gql`
        mutation($entidad: tbCobradorInputType)
        {
          tbCobrador
          {
          agregar(entidad: $entidad) {
              respuesta{
                cobid
                cobcodigo
                cobnombre
                cobrut
                cobcargo
                cobzona
                cobseccion
                cobcomision
              }
            }
          }
        }
       `
       ,
       refetchQueries: [{
         query: gql`
            query {
              tbCobrador{
                obtenerTodos {
                  respuesta
                  {
                    registros
                    {
                      cobid
                      cobcodigo
                      cobnombre
                      cobrut
                      cobcargo
                      cobzona
                      cobseccion
                      cobcomision
                    }
                  }
                }
              }
            }
         `
       }],
       
      variables: {
        'entidad': bodyx,
      }
    }, function (respuesta) {
      setTimeout(() => self.obtenerDatosCobrador(), 1000);

    });
  }
  
  onDelete(cob: Tbcobrador) {

    this.cobrador = { cobid: cob.cobid, cobcodigo: cob.cobcodigo, cobnombre: cob.cobnombre, cobrut: cob.cobrut, cobcargo: cob.cobcargo, cobzona: cob.cobzona, cobseccion: cob.cobseccion, cobcomision: cob.cobcomision };
    
    var bodyx = this.cobrador;
    var self = this;
    this.client.mutate({
      mutation: gql`
          mutation($entidad: tbCobradorInputType)
          {
            tbCobrador
            {
              eliminar(entidad: $entidad) {
              mensajes
                {
                  codigo
                  contexto
                  texto
                  tipo
                }
              }
            }
          }
       `,
      refetchQueries: [{
        query: gql`
          query {
            tbCobrador{
              obtenerTodos {
                respuesta
                {
                  registros
                  {
                    cobid
                    cobcodigo
                    cobnombre
                    cobrut
                    cobcargo
                    cobzona
                    cobseccion
                    cobcomision
                  }
                }
              }
            }
          }
        `
      }],
      variables: {
        'entidad': bodyx,//street
      }
    }, function (mensajes) {
      //console.log(mensajes);
      setTimeout(() => self.obtenerDatosCobrador(), 1000);
    });
    
  }

  actualizar(cobid: number, cobcodigo: string, cobnombre: string, cobrut: string, cobcargo: string, cobzona: string, cobseccion: string, cobcomision: any) {//, trID: number

    this.cobrador = { cobid: cobid, cobcodigo: cobcodigo, cobnombre: cobnombre, cobrut: cobrut, cobcargo: cobcargo, cobzona: cobzona, cobseccion: cobseccion, cobcomision: cobcomision };

    this.refrescar(this.cobrador);
    // console.log(veFono2);
    //console.log('inserto');
  }

  refrescar(cob: Tbcobrador) {
    let self = this;
    var bodyx = cob;
    //var self = this;
    this.client.mutate({
      mutation: gql`
        mutation($entidad: tbCobradorInputType)
        {
          tbCobrador
          {
          modificar(entidad: $entidad) {
              respuesta{
                cobid
                cobcodigo
                cobnombre
                cobrut
                cobcargo
                cobzona
                cobseccion
                cobcomision
              }
            }
          }
        }
       `
       ,
       refetchQueries: [{
         query: gql`
            query {
              tbCobrador{
                obtenerTodos {
                  respuesta
                  {
                    registros
                    {
                      cobid
                      cobcodigo
                      cobnombre
                      cobrut
                      cobcargo
                      cobzona
                      cobseccion
                      cobcomision
                    }
                  }
                }
              }
            }
         `
       }],
       
      variables: {
        'entidad': bodyx,
      }
    }, function (respuesta) {
      setTimeout(() => self.obtenerDatosCobrador(), 1000);

    });
  }
}
